<template>
  <el-dialog
    v-model="visible"
    class="app-update-dialog"
    width="520px"
    align-center
    :close-on-click-modal="!forceUpdate"
    :close-on-press-escape="!forceUpdate"
    :show-close="!forceUpdate"
    :before-close="handleBeforeClose"
    append-to-body
  >
    <template #header>
      <div class="update-header">
        <i class="fas fa-cloud-download-alt"></i>
        <div>
          <h3>{{ forceUpdate ? '发现重要更新' : '发现新版本' }}</h3>
          <p>建议更新到最新版本以获得更好体验</p>
        </div>
      </div>
    </template>

    <div class="update-meta">
      <span>当前版本 {{ clientVersion || '-' }}</span>
      <i class="fas fa-arrow-right"></i>
      <span class="now-version">最新版本 {{ nowVersion || '-' }}</span>
    </div>

    <div v-if="createdTime" class="update-time">更新时间：{{ createdTime }}</div>

    <div v-if="forceUpdate" class="force-tip">当前版本需更新后才能继续使用</div>

    <div v-if="updatedLog" class="update-log" v-html="updatedLog"></div>
    <div v-else class="update-log empty">暂无更新说明</div>

    <template #footer>
      <el-button v-if="!forceUpdate" @click="visible = false">稍后再说</el-button>
      <el-button type="primary" :loading="opening" @click="handleUpdate">
        {{ installMode === '1' ? '前往应用市场' : '立即下载' }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus'
import { isDesktopApp, openDesktopExternal, queryAppVersion } from '@/utils/appUpdate'

export default {
  name: 'AppUpdateDialog',
  data() {
    return {
      visible: false,
      opening: false,
      clientVersion: '',
      nowVersion: '',
      updatedLog: '',
      appUrl: '',
      createdTime: '',
      installMode: '0',
      forceUpdate: false
    }
  },
  mounted() {
    this.checkUpdate()
  },
  methods: {
    handleBeforeClose(done) {
      if (this.forceUpdate) return
      done()
    },
    async checkUpdate() {
      if (!isDesktopApp()) return
      try {
        const info = await queryAppVersion()
        if (!info) return
        this.clientVersion = info.clientVersion
        this.nowVersion = info.nowVersion
        this.updatedLog = info.updatedLog
        this.appUrl = info.appUrl
        this.createdTime = info.createdTime
        this.installMode = String(info.installMode ?? '0')
        this.forceUpdate = !!info.forceUpdate
        this.visible = true
      } catch (error) {
        console.warn('查询应用版本失败:', error)
      }
    },
    async handleUpdate() {
      if (!this.appUrl) {
        ElMessage.warning('暂无下载地址')
        return
      }
      this.opening = true
      try {
        const result = await openDesktopExternal(this.appUrl)
        if (result?.ok === false) {
          ElMessage.error(result.message || '打开下载地址失败')
          return
        }
        ElMessage.success('已打开下载链接，安装完成后请重新启动应用')
        if (!this.forceUpdate) {
          this.visible = false
        }
      } catch (error) {
        console.error('打开下载地址失败:', error)
        ElMessage.error('打开下载地址失败')
      } finally {
        this.opening = false
      }
    }
  }
}
</script>

<style>
.app-update-dialog .el-dialog__header {
  margin-right: 0;
  padding-bottom: 8px;
}

.app-update-dialog .el-dialog__body {
  padding-top: 8px;
}
</style>

<style scoped>
.update-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.update-header i {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #570df8;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.update-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.3;
}

.update-header p {
  margin-top: 4px;
  font-size: 13px;
  color: #6b7280;
}

.update-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f5f3ff;
  border-radius: 8px;
  color: #4b5563;
  font-size: 13px;
}

.update-meta i {
  font-size: 12px;
  color: #570df8;
}

.now-version {
  color: #570df8;
  font-weight: 600;
}

.update-time {
  margin-top: 10px;
  font-size: 12px;
  color: #9ca3af;
}

.force-tip {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 13px;
}

.update-log {
  margin-top: 14px;
  max-height: 280px;
  overflow: auto;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  color: #374151;
  font-size: 14px;
  line-height: 1.7;
}

.update-log.empty {
  color: #9ca3af;
}

.update-log :deep(img) {
  max-width: 100%;
  height: auto;
}

.update-log :deep(p) {
  margin-bottom: 8px;
}

.update-log :deep(a) {
  color: #570df8;
}
</style>
